import { notification } from "antd";
import { useWorker } from "@sqreem-frontend/sqapp";

const sqWorker = useWorker()
class WorkerServices {
  constructor() {
    this.mainworker = sqWorker.create(`${process.env.PUBLIC_URL}/workers/mainworker.js?`);
    this.qrworker = sqWorker.create(`${process.env.PUBLIC_URL}/workers/quickreportworker.js?`);
    this.reportworker = sqWorker.create(`${process.env.PUBLIC_URL}/workers/report.js?`);
    this.treeCacheWorker = sqWorker.create(`${process.env.PUBLIC_URL}/workers/treecache.js?`);
    this.whitespaceworker = sqWorker.create(`${process.env.PUBLIC_URL}/workers/whitespaceworker.js?`);
    this.whitespaceworker.on("wsCsvDownloadProgress", ([status]) => {
      const { message, isDone } = status;
      if (isDone) {
        notification.destroy("wsCsvDownloadProgress");
      } else
        notification.info({
          message: "Downloading CSV",
          description: <span style={{ color: "#52c41a" }}>{message}</span>,
          duration: null,
          placement: "topRight",
          closable: true,
          // closeIcon: (<div />),
          key: "wsCsvDownloadProgress"
        });
    });
  }

  whitespaceDynamic(fnc, params) {
    return this.whitespaceworker.post(fnc, params)
  }

  searchInQuickReport(list, searchedText) {
    return this.qrworker.post("searchInQuickReport", [list, searchedText.toLocaleLowerCase()])
  }

  countItems(list) {
    return this.mainworker.post("countItems", [list])
  }

  parseMinifiedFreeformResult(list) {
    return this.mainworker.post("parseMinifiedFreeformResult", [...list])
  }

  searchInTreeCategory(list) {
    return this.mainworker.post("searchInTree", [...list])
  }

  addBehaviouralSegmentFolderParser(params) {
    return this.reportworker.post("addBehaviouralSegmentFolderParser", [params])
  }

  parseReportData(params) {
    return this.reportworker.post("parseReportData", [...params])
  }

  clearTiktokAudienceSize(params) {
    return this.reportworker.post("clearTiktokAudienceSize", [...params])
  }

  setTiktokAudienceSize(params) {
    return this.reportworker.post("setTiktokAudienceSize", [...params])
  }

  report(fnc, params) {
    return this.reportworker.post(fnc, [...params])
  }

  whitespace(fnc, params) {
    return this.whitespaceworker.post(fnc, [...params])
  }

  parseReportJSONtoSave(params) {
    return this.mainworker.post("parseReportJSONtoSave", [...params])
  }

  getRelated(params) {
    return this.treeCacheWorker.post("getRelated", [...params])
  }

  checkMOKBCache(params) {
    return this.treeCacheWorker.post("checkMOKBCache", [...params])
  }

  setMOKBCache(params) {
    return this.treeCacheWorker.post("setMOKBCache", [...params])
  }

  getRelatedByFolders(params) {
    return this.treeCacheWorker.post("getRelatedByFolders", [...params])
  }

  getTreeLocalCached(params) {
    return this.treeCacheWorker.post("checkIfCached", [params])
  }

  setTreeLocalCached(params) {
    return this.treeCacheWorker.post("setTreeLocalCacheData", [...params])
  }

  getMOKBTree(params) {
    return this.treeCacheWorker.post("getMOKBTree", [params])
  }
  
  getMOKBTreeJSON(params) {
    return this.treeCacheWorker.post("getMOKBTreeJSON", [params])
  }

  lockFolderBaseFromConfig(params) {
    return this.treeCacheWorker.post("lockFolderBaseFromConfig", [...params]).then((resp) => {
      if (resp.error) {
        notification.error({
          message: "",
          description: "Something went wrong. (Error code: ERR-CFC)",
          duration: 3000
        });
        return []
      }
      return resp
    })
  }

  clearCache(params) {
    return this.mainworker.post("clearCache", [...params])
  }

  setCache(params) {
    return this.mainworker.post("setCache", [...params])
  }

  checkIfHasCache(params) {
    return this.mainworker.post("checkIfHasCache", [...params])
  }

  getObjectID(params) {
    return this.mainworker.post("getObjectID", [...params])
  }

  clearWhiteSpaceCache(params) {
    return this.whitespaceworker.post("clearWhiteSpaceCache", [...params])
  }

  downloadCSVWS(params) {
    return this.whitespaceworker.post("downloadCSVWS", [...params])
  }

  clearWhiteSpaceCompetitorCache(params) {
    return this.whitespaceworker.post("clearWhiteSpaceCompetitorCache", [...params])
  }

  getWhiteSpaceCache(params) {
    return this.whitespaceworker.post("getWhiteSpaceCache", [...params])
  }

  parseWhitespaceReponse(params) {
    return this.whitespaceworker.post("parseWhitespaceReponse", [...params])
  }

  appendScoreToCategory(params) {
    return this.whitespaceworker.post("appendScoreToCategory", [...params])
  }
  setAudienceCache(params) {
    return this.whitespaceworker.post("setAudienceCache", [...params])
  }
  getAudienceCache(params) {
    return this.whitespaceworker.post("getAudienceCache", [...params])
  }
  clearAudienceCache(params) {
    return this.whitespaceworker.post("clearAudienceCache", [...params])
  }

  appendScoreToCategoryV2(params) {
    return this.whitespaceworker.post("appendScoreToCategoryV2", [...params])
  }
  getAudienceSizeCache(params) {
    return this.whitespaceworker.post("getAudienceSizeCache", [...params])
  }

}
export default new WorkerServices();
